__webpack_require__.p = "https://virtuescards.org/";